import styled from 'styled-components';
import { device } from '../MainContents/Style/StyleDevice';
import Flow1 from '../../img/flow1.jpg';
import Flow3 from '../../img/flow3.jpg';    
import MakeImg from '../../img/make.jpg';    
import HrImg from '../../img/hr-maru.png';

const Main =styled.div`
    margin-top: 50px;
    width: 100%;

`
const Header =styled.h2`
    margin-bottom: 30px;
    padding: 15px;
    font-size: 1.5rem;
    background-color: orange;
    color: rgb(255, 255, 255);
    border-radius: 7px;
`
const HumanImg =styled.img`
    border-radius: 50%;
`
const HumanP =styled.p`padding-left: 62px;`

const LessonFlow: React.VFC = () => {
  return (
    <Main>
        <p className='text-center text-2xl font-bold'>授業の流れ(１コマ６０分)</p>
        <img className='mt-2 mb-5' src={HrImg} width={'100%'} alt='hr' />
        
        <div className='mt-3 grid grid-cols-3 gap-4 sm:grid-cols-3 md:grid-cols-9'>
            <div className='col-span-3'>
                <div>
                    {/* <img src={Flow1} alt="" /> */}
                    <div style={{background: 'whitesmoke'}}></div>
                    <p className='font-bold'>新しい知識を学ぶ</p>
                    <p>まずは、クラスみんなで理科や算数の新しい知識を講師から学びます。</p>
                </div>
            </div>
            <div className='col-span-3'>
                <div>
                    {/* <img src={MakeImg} alt="" /> */}
                    <div style={{background: 'whitesmoke'}}></div>
                    <p className='font-bold'>つくる</p>
                    <p>学んだ知識を活かして制作。理数の原理を考えながら創造力を育みます</p>
                </div>
            </div>
            <div className='col-span-3'>
                <div>
                    {/* <img src={Flow3} alt="" /> */}
                    <div style={{background: 'whitesmoke'}}></div>
                    <p className='font-bold'>実験・プレゼン</p>
                    <p>制作したもので実験やゲームをする中で改善点を発見し、改造を加えることで、 応用力を引き出します。</p>
                </div>
            </div>
        </div>
        
    </Main>
    
  );
}
export default LessonFlow;